const apiScope1 = process.env.REACT_APP_API_SCOPE1 + "";

function baseLocationUrl() {
  const url = window.location.href;
  if (url.includes("backoffice")) {
    return window.location.origin + "/backoffice";
  } else {
    return window.location.origin;
  }
}

export const msalConfig = {
  auth: {
    clientId: `${process.env.REACT_APP_CLIENTID}`,
    authority: `${process.env.REACT_APP_AUTHORITY}`,
    redirectUri: baseLocationUrl(),
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  scopes: ["User.Read", "profile", "User.Read.All", "ProfilePhoto.Read.All","openid"],
};
export const graphConfigGroup = {
  graphMeEndpoint:
    "https://graph.microsoft.com/v1.0/me/transitiveMemberOf/microsoft.graph.group?$top=999",
};

export const appConfig = {
  appEndpoint: {
    baseUrl: window.location.origin,
    baseLocation: baseLocationUrl(),
  },
};

export const protectedResources = {
  apiHRMobile: {
    baseApi:  process.env.REACT_APP_API_END_POINT + "",
    endpoint: process.env.REACT_APP_API_END_POINT + "/api/v1",
    menuApi: process.env.REACT_APP_API_MENU_ITEMS + "/MemuService",
    scopes: [apiScope1],
  },
  graphMe: {
    endpoint: "https://graph.microsoft.com/v1.0/me",
    scopes: ["User.Read", "profile", "User.Read.All", "ProfilePhoto.Read.All","openid"],
  },
  graphPhoto: {
    endpoint: "https://graph.microsoft.com/v1.0/me/photo/$value",
    scopes: ["User.Read", "profile", "User.Read.All", "ProfilePhoto.Read.All","openid"],
  },
  graphMessages: {
    endpoint: "https://graph.microsoft.com/v1.0/me/messages",
    scopes: ["Mail.Read"],
  },
  armTenants: {
    endpoint: "https://management.azure.com/tenants?api-version=2020-01-01",
    scopes: ["https://management.azure.com/user_impersonation"],
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [...protectedResources.apiHRMobile.scopes],
};

export const loginRequestLocal = {
  scopes: [...protectedResources.apiHRMobile.scopes],
};

export const profileRequest = {
  scopes: [...protectedResources.graphMe.scopes],
};
